/* eslint-disable linebreak-style */
import { comparaIndicatori } from '../strapi/strapi.utils';

// Mapăm indicatorii la funcțiile lor de actualizare
const INDICATOR_TO_ACTION = {
  'Produse': 'loadProduseStart',
  'Materiale': 'loadMaterialeStart',
  'Optionale': 'loadOptionaleStart',
  'Culori': 'loadCuloriStart',
  'PreturiTabelare': 'loadPreturiTabelareStart',
  'Informari': 'loadInformariStart'
};

export const verificaIndicatoriSiActualizeaza = async (idFirma, props) => {
  const {
    loadProduseStart,
    loadMaterialeStart,
    loadOptionaleStart,
    loadCuloriStart,
    loadPreturiTabelareStart,
    loadInformariStart,
    loadIndicatoriStart
  } = props;

  try {
    let s_aFacutUpdate = false;
    
    // Verificăm fiecare indicator și actualizăm doar datele necesare
    for (const [indicator, actionName] of Object.entries(INDICATOR_TO_ACTION)) {
      const suntEgali = await comparaIndicatori(indicator);
      
      if (!suntEgali) {
        console.log(`Actualizare necesară pentru ${indicator}`);
        // Apelăm funcția de actualizare corespunzătoare
        const updateFunction = props[actionName];
        if (updateFunction) {
          await updateFunction();
          s_aFacutUpdate = true;
        }
      }
    }

    // Dacă s-a făcut cel puțin un update, actualizăm și indicatorii
    if (s_aFacutUpdate) {
      await loadIndicatoriStart();
    }

    return s_aFacutUpdate; // Returnăm dacă s-a făcut vreun update
  } catch (error) {
    console.error('Eroare la actualizarea datelor:', error);
    throw error; // Propagăm eroarea pentru a fi gestionată în handleButComanda
  }
};

export const dataFormatRO=(timestamp)=>{
  var data= new Date(Date.parse(timestamp)*1)
  return data.toLocaleString('ro-RO')
}

export const dynamicSort=(property)=> {
  var sortOrder = 1;
  if(property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a,b) {
    /* next line works with strings and numbers, 
       * and you may want to customize it to your needs
       */
    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    return result * sortOrder;
  }
}

export function dynamicMultipleSort() {
  /*
    * salvează obiectul arguments deoarece va fi suprascris
    * trebuie menționat că obiectul arguments este un obiect asemănător unui array
    * format din numele proprietăților după care se sortează
    */
  var props = arguments;
  return function (obj1, obj2) {
      var i = 0, result = 0, numberOfProperties = props.length;
      /* încearcă să obții un rezultat diferit de 0 (egal)
       * atâta timp cât avem proprietăți suplimentare de comparat
       */
      while(result === 0 && i < numberOfProperties) {
          result = dynamicSort(props[i])(obj1, obj2);
          i++;
      }
      return result;
  }
}